import script from "./editUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./editUserForm.vue?vue&type=script&setup=true&lang=js"

import "./editUserForm.vue?vue&type=style&index=0&id=71b01a6e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b01a6e"]])

export default __exports__